import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../../assets/logo0005.jpeg'; 

const categories = [
  { id: 1, name: 'Thriller', path: '/category/thriller' },
  { id: 2, name: 'Science Fiction', path: '/category/sci-fi' },
  { id: 3, name: 'Romance', path: '/category/romance' },
  { id: 4, name: 'History', path: '/category/history' },
  { id: 5, name: 'Children', path: '/category/children' },
];

export const Sidebar = ({ isOpen }) => {
  return (
    <aside className={`fixed inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} w-64 bg-gray-100 dark:bg-gray-800 transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:w-64 z-20`}>
    <div 
      className={`bg-white dark:bg-gray-800 w-64 min-h-screen shadow-lg fixed top-0 left-0 z-20 transition-transform duration-300 ease-in-out transform ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <div className="p-5 pt-20">
        <Link to="/" className="flex items-center justify-center mb-6">
          <img src={Logo} alt="Logo" className="h-16 w-auto" />
        </Link>
        <nav>
          <h2 className="text-lg font-semibold mb-4 text-gray-700 dark:text-white">Categories</h2>
          <ul>
            {categories.map((category) => (
              <li key={category.id} className="mb-2">
                <Link 
                  to={category.path}
                  className="block py-2 px-4 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition duration-150 ease-in-out"
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
    </aside>
  );
};